import './Filter.css';

function FilterRow({ gpuName, isSelected, onSelect }) {
  return (
    <button
      type="button"
      className={`FilterRow${isSelected ? ' is-selected' : ''}`}
      onClick={() => onSelect(gpuName)}
    >
      {gpuName}
    </button>
  );
}

export default FilterRow;
